import { render, staticRenderFns } from "./CardThumbnail.vue?vue&type=template&id=4bb13148&"
import script from "./CardThumbnail.vue?vue&type=script&lang=js&"
export * from "./CardThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./CardThumbnail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports